import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiOption = (_param)=>{
    var { biData , innerRef , stopPropagation  } = _param, props = _object_without_properties(_param, [
        "biData",
        "innerRef",
        "stopPropagation"
    ]);
    // _value is used in useBiClickLogger to compare with
    //  the parent select's value and recognize a change
    // so add it automatically if it's not there
    if (biData && props.value) {
        biData._value = biData._value || props.value.toString();
    }
    const { setTrackingRef  } = useBiClickLogger(biData, stopPropagation);
    return /*#__PURE__*/ React.createElement("option", _extends({}, props, {
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
        }
    }));
};
BiOption.displayName = 'BiOption';
export default BiOption;
